import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["formDeliveryPaidManual", "formAmountPaidManual"];

  connect() {
  }

  change(event) {
    this.toggleForm(event.target.value);
  }

  toggleForm(selectedValue) {
    this.toggleVisibility(this.formDeliveryPaidManualTarget, selectedValue === "delivery_paid_manual");
    this.toggleVisibility(this.formAmountPaidManualTarget, selectedValue === "open_target_purchase_amount");
  }

  toggleVisibility(element, isVisible) {
    if (isVisible) {
      element.classList.remove("d-none");
    } else {
      element.classList.add("d-none");
    }
  }
}
